module.exports = __webpack_public_path__ + "img/sheinx.dc03bae5.png";